import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const Voice00Table: GenericTableSchemaInterface = {
  id: "voice-00",
  name: "Voice 00",
  description: "This table contains data around our voice workflows.",
  core: CoreType.STORAGE,
  mapping: {
    c01: {
      name: "Org Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Location FMS ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Location Name",
      variable: VarKey.LocationName
    },
    c04: {
      name: "User ID",
      variable: VarKey.UserId
    },
    c05: {
      name: "User Persona",
      variable: VarKey.UserPersona
    },
    c06: {
      name: "Lease Balance",
      variable: VarKey.LeaseBalance
    },
    c07: {
      name: "Lease Account Status",
      variable: VarKey.LeaseAccountStatus
    },
    c08: {
      name: "Lease Payment Status",
      variable: VarKey.LeasePaymentStatus
    },
    c09: {
      name: "Welcome (call starts)"
    },
    c10: {
      name: "Automation"
    },
    c11: {
      name: "Start"
    },
    c12: {
      name: "SMS Sent"
    },
    c13: {
      name: "Inside Business Hours"
    },
    c14: {
      name: "Outside Business Hours"
    },
    c15: {
      name: "Ask to Escalate"
    },
    c16: {
      name: "Actual Escalation"
    },
    c17: {
      name: "Integration Information Found"
    },
    c18: {
      name: "Integration Information Not Found"
    },
    c19: {
      name: "Account Active"
    },
    c20: {
      name: "Account Inactive"
    },
    c21: {
      name: "Account Past Due"
    },
    c22: {
      name: "Account Unknown"
    },
    c23: {
      name: "Account Else"
    },
    c24: {
      name: "Hangup (call ends)"
    },
    c25: {
      name: "LeaseId",
      variable: VarKey.UserLeaseId
    }
  }
};
